import React, { useContext } from 'react'
import logo from "../assets/logo.jpg";
import { IoArrowBack, IoCart, IoLogInOutline, IoSearchSharp } from 'react-icons/io5'
import { CartContext } from '../Contexts/CartContext';
import '../css/header.css'
import { Link } from 'react-router-dom';

const Header = ({ page, openModal }) => {
  const { quantity } = useContext(CartContext);

  return (
    
    <header>
        <div className="logo">
            <img src={logo} alt="Logo de Sunu Mango" />
        </div>

        {page == "order" ?
          <div className="search-bar">
              <div className="bar">
                  <input type="text" placeholder="Rechercher une variété..." />
                  <button><IoSearchSharp /></button>
              </div>
          </div> : <div></div>
        }
        
        <nav>
          {page == "order" ?
            <button className="cart" onClick={openModal}>
              <span className="icon"><IoCart /></span>
              <span className="text">Panier ({quantity})</span>
            </button> :
            <Link to="/">
              <span className="icon"><IoArrowBack /></span>
              <span className="text">Page de commande</span>
            </Link>
          }
        </nav>
    </header>
  )
}

export default Header